import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Paper,
  Table,
  Group,
  Text,
  Avatar,
  Badge,
  Button,
  ActionIcon,
  Title,
  Stack,
  LoadingOverlay,
} from "@mantine/core";
import { IconEdit, IconExternalLink, IconPlus } from "@tabler/icons-react";
import { API_BASE_URL } from "../../config/baseUrls";

const BASE_URL = `${API_BASE_URL}/shop-owner`;
const getHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("shopToken")}`,
});

export default function GlobalProductList() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${BASE_URL}/all-products`, { headers: getHeaders() })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) setProducts(data.data);
      })
      .finally(() => setLoading(false));
  }, []);

  const rows = products.map((product) => (
    <Table.Tr key={product.id}>
      <Table.Td>
        <Group gap="sm">
          <Avatar src={product.media[0]?.url} radius="sm" size="md" />
          <Text size="sm" fw={500}>
            {product.title}
          </Text>
        </Group>
      </Table.Td>
      <Table.Td>
        {product.shopFront ? (
          <Badge variant="light" color="blue">
            {product.shopFront.name}
          </Badge>
        ) : (
          <Badge variant="outline" color="gray">
            Unassigned
          </Badge>
        )}
      </Table.Td>
      <Table.Td>₹{product.unitPrice}</Table.Td>
      <Table.Td>
        <Badge color={product.status === "AVAILABLE" ? "green" : "gray"} dot>
          {product.status}
        </Badge>
      </Table.Td>
      <Table.Td>
        <Group gap={0} justify="flex-end">
          <ActionIcon
            variant="subtle"
            color="gray"
            onClick={() => {
              navigate(`/shop-owner/products/edit/${product.id}`);
            }}
          >
            <IconEdit size={16} />
          </ActionIcon>
          {product.shopFrontId && (
            <ActionIcon
              variant="subtle"
              color="blue"
              onClick={() =>
                navigate(`/shop-owner/shops/${product.shopFrontId}`)
              }
            >
              <IconExternalLink size={16} />
            </ActionIcon>
          )}
        </Group>
      </Table.Td>
    </Table.Tr>
  ));

  return (
    <Stack>
      <Group justify="space-between">
        <div>
          <Title order={2} className="ota-gradient-text">
            My Products
          </Title>
          <Text c="dimmed">Global inventory across all shops</Text>
        </div>
        <Button
          leftSection={<IconPlus size={18} />}
          onClick={() => navigate("/shop-owner/products/new")}
          className="btn-ota-primary"
        >
          Create Product
        </Button>
      </Group>

      <Paper withBorder radius="md" p="md" pos="relative" mih={200}>
        <LoadingOverlay visible={loading} />
        <Table verticalSpacing="sm">
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Product</Table.Th>
              <Table.Th>Shop</Table.Th>
              <Table.Th>Price</Table.Th>
              <Table.Th>Status</Table.Th>
              <Table.Th style={{ textAlign: "right" }}>Actions</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>{rows}</Table.Tbody>
        </Table>
        {!loading && products.length === 0 && (
          <Text c="dimmed" ta="center" py="xl">
            No products found.
          </Text>
        )}
      </Paper>
    </Stack>
  );
}
